
import {
    CAMERA_RADIUS
} from '../variable/constant';
function getPointsArr(params) {
    let { startPosition, sourcePosition, position, bindingType, bindingY, bottomY = 0 } = params;
    let curve = null;
    let pointsArr = [];
    const bottomPosition = bindingType === 'westStyle'
        ? (() => {
            const standardRate = (bottomY - bindingY) / (position.y - bindingY);
            return new THREE.Vector3(
                standardRate * (position.x - startPosition.x) + startPosition.x,
                bottomY,
                standardRate * (position.z - startPosition.z) + startPosition.z
            );
        })()
        : new THREE.Vector3(
            (sourcePosition ? sourcePosition.x : position.x) * 0.05 + startPosition.x,
            bottomY,
            (sourcePosition ? sourcePosition.z : position.z) * 0.05 + startPosition.z
        );
    if (bindingType === 'westStyle') {
        curve = new THREE.LineCurve3(
            new THREE.Vector3(position.x, position.y, position.z),
            bottomPosition
        );
    } else {
        curve = new THREE.QuadraticBezierCurve3(
            new THREE.Vector3(position.x, position.y, position.z),
            new THREE.Vector3(startPosition.x, bindingY, startPosition.z),
            bottomPosition
        );
    }
    for (let point of curve.getPoints(128)) {
        pointsArr.push(point.x, point.y, point.z);
    }
    return pointsArr;
}

export default getPointsArr
